import featureNames from 'constants/feature_names';

angular.module('shared').directive('templateRequiresObjectMessage', function() {
  return {
    restrict: 'E',
    scope: {
      template: '='
    },
    controller: ["$scope", function($scope) {
      $scope.featureNames = featureNames;
      return $scope.sequenceType = function() {
        switch (false) {
          case !$scope.template.requires_booking_object:
            return 'Booking';
          case !$scope.template.requires_membership_object:
            return 'Membership';
          case !$scope.template.requires_invoice_object:
            return 'Payment';
          case !$scope.template.requires_member_style_object:
            return 'Style';
          case !$scope.template.requires_member_grading_object:
            return 'Grading';
          case !$scope.template.requires_contact_suspension_object:
            return 'Suspension';
          case !$scope.template.requires_recurring_booking_detail_object:
            return 'Recurring booking';
          case !$scope.template.requires_booking_cancellation_object:
            return 'Booking cancelled';
          case !$scope.template.requires_late_booking_cancellation_object:
            return 'Booking late-cancelled';
          case !$scope.template.requires_waitlist_attendee_object:
            return 'Contact added to event waitlist';
          case !$scope.template.requires_performed_workout_object:
            return 'Performed workout';
        }
      };
    }],
    template: '<div class="alert alert-danger is-sm"> This template can only be used in a {{sequenceType()}} {{featureNames.SEQUENCE_LOWERCASE}}. Please choose another template. </div>'
  };
});
